"use client";

import { ChevronRight } from "lucide-react";
import { useTranslations } from "next-intl";

import { SettingsRow } from "@/components/settings/SettingsRow";
import { SettingsSection } from "@/components/settings/SettingsSection";

export function LegalSection() {
  const t = useTranslations("settings");
  const currentYear = new Date().getFullYear();

  return (
    <>
      <SettingsSection className="p-0 overflow-hidden">
        <SettingsRow href="/privacy" className="justify-between">
          <h3 className="font-medium">{t("privacyPolicy")}</h3>
          <ChevronRight className="size-5 shrink-0 text-muted-foreground" aria-hidden />
        </SettingsRow>

        <div className="border-t border-border mx-4" />

        <SettingsRow href="/terms" className="justify-between">
          <h3 className="font-medium">{t("termsOfService")}</h3>
          <ChevronRight className="size-5 shrink-0 text-muted-foreground" aria-hidden />
        </SettingsRow>
      </SettingsSection>

      <p className="mt-4 text-center text-xs text-muted-foreground">
        &copy; {currentYear} Nombox. All rights reserved.
      </p>
    </>
  );
}
